export const localStorageKeys = {
  USER_SEARCH_PREFERENCES: 'userSearchPreferences',
  RECENT_METHODS: 'recentMethods',
  RECENT_SEARCHES: 'recentSearches',
  SELECTED_METHOD: 'selectedMethod',
  SHOW_COMMENTS: 'showComments',
  FLOW_LAYOUT: 'flowLayout',
  FLOW_VIEW_MODE: 'flowViewMode',
  SUPPLY_CHAIN_VIEW_MODE: 'supplyChainViewMode',
  LICENSED_TOUR_COMPLETED: 'ecoquery-onboarding-completed',
  UNLICENSED_TOUR_COMPLETED: 'ecoquery-unlicensed-onboarding-completed',
  SEARCH_ORIGIN: 'searchOrigin',
  SUPPLY_CHAIN_INFO_CARD_DISMISSED: 'supplyChainInfoCardDismissed',
};
